import React from 'react';
import { Icon } from './Icon.js';
export const IconFormFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("rect", { x: "2", y: "4.5", width: "14", height: "5", rx: "1.75", ry: "1.75", fill: "currentColor" }),
        React.createElement("rect", { x: "2", y: "11", width: "14", height: "5", rx: "1.75", ry: "1.75", fill: "currentColor" }),
        React.createElement("path", { d: "M3.75,3H7.75c.414,0,.75-.336,.75-.75s-.336-.75-.75-.75H3.75c-.414,0-.75,.336-.75,.75s.336,.75,.75,.75Z", fill: "currentColor", "data-color": "color-2" })));
};
//# sourceMappingURL=IconFormFill18.js.map